import script from "./PortalLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalLayout.vue?vue&type=script&setup=true&lang=js"

import "./PortalLayout.vue?vue&type=style&index=0&id=454f1d65&lang=scss"

const __exports__ = script;

export default __exports__